/* eslint-disable no-var */
import { useCallback, useMemo, useState } from "react";

// Redux
import { useDispatch } from "react-redux";
import { updateSelectedFlight } from "src/redux/actions/flights/FlightData.Actions";

// Material UI Styling
import { Grid, Typography, Button } from "@mui/material";
import { TextField } from "src/components/FormikComponents/TextField";

export interface IFlightMessages {
  flightId: string;
  windowId: string;
  setRefresh: (refresh: boolean) => void;
}

/**
 * Movement Message - 'Flight Messages' form.
 * @param props -
 */
export const FlightMessages = (props: IFlightMessages): JSX.Element => {
  const { flightId, setRefresh } = props;
  const dispatch = useDispatch();
  const [comment, setComment] = useState<string>(null);
  const formValid: boolean = useMemo(() => (comment ? true : false), [comment]);
  // const user = useSelector((state: IRootState) => state.authentication.attributes);

  // Variables added to minimize the possibiliy of sending duplicate messages.
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [messageSent, setMessageSent] = useState<string>(null);

  const clearForm = useCallback((): void => {
    setComment(null);
    setMessageSent(null);
  }, []);

  const submitForm = async (): Promise<void> => {
    setSubmitting(true);

    const messagePayload = { comment: comment, updateType: "DepartureMessage" };

    var result = await dispatch(updateSelectedFlight(flightId, messagePayload));
    // Debug.log("departure message", messagePayload);
    // if successful - post message for user and lock form
    if (result && result.hasOwnProperty("newEvent")) {
      setMessageSent("Flight Comment submitted Successfully, reset tool to submit another.");
      setRefresh(true);
    }
    setSubmitting(false);
  };

  return (
    <Grid className="arrival_message_form" container>
      <p className="required_fields_label">required fields</p>
      <Grid container className="required_fields">
        <Grid
          item
          xs={12}
          className="note_field"
          sx={{
            width: "100%",
            maxWidth: 600,
            "& .MuiFormLabel-root": {
              minWidth: 150,
            },
          }}
        >
          <TextField
            label="Comment"
            className="flight_message_input"
            onChange={(e: any) => !!e && !!e.target && setComment(e.target.value)}
            name="flight_comment_string"
            value={comment}
            placeholder=""
            multiline={true}
            maxRows={20}
            minRows={10}
            sx={{ width: "100%" }}
          />
        </Grid>
      </Grid>

      {messageSent && (
        <Typography variant="caption" color="textPrimary" style={{ margin: "0px 10px" }}>
          {messageSent}
        </Typography>
      )}

      <Grid item className="buttons">
        <Button
          id={"clear_flightMessage_form_btn"}
          className="form_buttons"
          variant="contained"
          color="secondary"
          disabled={!comment}
          type="button"
          onClick={() => clearForm()}
        >
          Reset
        </Button>
        <Button
          id={"submit_flightMessage_form_btn"}
          className="form_buttons"
          variant="contained"
          color="primary"
          disabled={!formValid || submitting || !!messageSent}
          type="button"
          onClick={() => submitForm()}
        >
          Submit
        </Button>
      </Grid>
    </Grid>
  );
};
